module.exports = __webpack_public_path__ + "media/images/LearnMore12-318aa768868f81e22aedabd075d4e4bd.png";